// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__-uZOb","navItem":"BottomNav_navItem__GtHdU","icon":"BottomNav_icon__mFalw","label":"BottomNav_label__WokrC","active":"BottomNav_active__4l86U"};